import React from 'react';
import WellList from './components/WellList';
// import ConnectionTest from './components/ConnectionTest';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>瑞翊工程有限公司</h1> <h1>水井資訊管理系統</h1>

      </header>

      <main>
        {/* <ConnectionTest /> */}
        <hr style={{ margin: '40px 0', borderColor: '#ccc' }} />
        <WellList />
      </main>
    </div>
  );
}

export default App;
